export function showInnerLinks(event) {
    const innerLink = event.currentTarget.querySelector('.inner-link');
    if (innerLink) {
      innerLink.style.maxHeight = '500px';
    }
    const icon = event.currentTarget.querySelector('svg');
    if (icon) {
      icon.style.transform = 'rotate(180deg)';
    }
  }
  
  export function hideInnerLinks(event) {
    const innerLink = event.currentTarget.querySelector('.inner-link');
    if (innerLink) {
      innerLink.style.maxHeight = '0';
    }
    const icon = event.currentTarget.querySelector('svg');
    if (icon) {
      icon.style.transform = 'rotate(0deg)';
    }
  }